import { createApi } from "@reduxjs/toolkit/query/react";
import apiBaseQuery from "./axiosBaseQuery";
import getTenantId from "../../components/Tenent";

export const ITEMS_API_REDUCER_KEY = "inputItemsApi";
const tenantId = getTenantId();

export const inputItemsApi = createApi({
  reducerPath: ITEMS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["input-items"],
  endpoints: (builder) => ({
    getCategoriesWithEmissions: builder.query({
      query: ({ inputGroupId }) => {
        if (!inputGroupId) {
          return;
        }
        return {
          url: `/emissions/category-wise-total-emission/?input_group=${inputGroupId}&limit=20`,
        };
      },
      providesTags: ["input-items"],
    }),
    getCategoryInputItems: builder.query({
      query: ({ inputGroupId, categoryId, page, limit }) => {
        if (!inputGroupId || !categoryId) {
          return;
        }
        return {
          url: `/emissions/emission-input-items/?input_group=${inputGroupId}&category=${categoryId}&page=${
            page || 1
          }&limit=${limit || 50}`,
        };
      },
      providesTags: ["input-items"],
    }),
    getPurchasedGoodsInputItems: builder.query({
      query: ({
        inputGroupId,
        categoryId,
        page,
        limit,
        mapped_activities,
        mapped_suppliers,
        q,
      }) => {
        if (!inputGroupId || !categoryId) {
          return;
        }

        const queryParams = `${
          mapped_activities ? "&mapped_activities=" + mapped_activities : ""
        }${
          mapped_suppliers
            ? (mapped_activities ? "&" : "") +
              "&mapped_suppliers=" +
              mapped_suppliers
            : ""
        }`;

        return {
          url: `/emissions/emission-input-items/?input_group=${inputGroupId}&category=${categoryId}&page=${
            page || 1
          }${queryParams}&q=${q}&limit=${limit || 50}`,
        };
      },
      providesTags: ["input-items"],
    }),

    createInputItem: builder.mutation({
      query: (body) => ({
        url: "/emissions/emission-input-items/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["input-items"],
    }),
    deleteInputItem: builder.mutation({
      query: (id) => {
        return {
          url: `/emissions/emission-input-items/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["input-items"],
    }),
    updateInputItem: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/emissions/emission-input-items/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["input-items"],
    }),
    retainRejectInputItem: builder.mutation({
      query: ({ id, action }) => ({
        url: `/emissions/emission-input-ititemsems/${id}/duplicate/${action}/`,
        method: "POST",
      }),
      invalidatesTags: ["input-items"],
    }),
    uploadInputItems: builder.mutation({
      query: ({ inputGroupId, body }) => {
        if (!inputGroupId) {
          return;
        }
        return {
          url: `/emissions/portfolio/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["input-items"],
    }),

    deleteUploadedFile: builder.mutation({
      query: (id) => {
        return {
          url: `/emissions/portfolio/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["input-items"],
    }),
    getPortfolioList: builder.query({
      query: ({ inputGroupId, categoryId }) => {
        console.log("inputGroupId", inputGroupId);
        if (!inputGroupId) {
          return;
        }
        return {
          url: `/emissions/portfolio/?input_group=${inputGroupId}&category=${categoryId}&limit=100`,
        };
      },
      providesTags: ["input-items"],
    }),
    getCeleryTaskStatus: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `/celery/${id}`,
        };
      },
      providesTags: ["input-items"],
    }),
    getPurchasedGoodsStats: builder.query({
      query: ({ categoryId, input_group }) => {
        if (!categoryId || !input_group) {
          return;
        }
        return {
          url: `emissions/portfolio-analysis/?input_group=${input_group}&category=${categoryId}`,
        };
      },
      providesTags: ["input-items"],
    }),
    getAllEmissionWith: builder.query({
      query: ({ year }) => {
        return {
          url: `/emissions/category-wise-total-emission/?limit=20`,
        };
      },
      providesTags: ["input-items"],
    }),
    //generic upload apis
    getUploadInputItems: builder.query({
      query: ({
        page = 1,
        limit = 100,
        q,
        input_group,
        category,
        organization_taxonomy,
        mapped_activities,
        start_date,
        end_date,
      }) => {
        const params = {
          page,
          limit,
          q,
          input_group,
          category,
          mapped_activities,
          organization_taxonomy,
          start_date,
          end_date,
        };

        // Filter out undefined parameters
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(([_, v]) => v !== undefined)
        );
        return {
          url: `/emissions/emission-input-items/`,
          params: filteredParams,
        };
      },
      providesTags: ["input-items"],
    }),
    GetUploadInputItemsData: builder.query({
      query: ({
        page = 1,
        limit = 100,
        q,
        input_group,
        category,
        organization_taxonomy,
        mapped_activities,
        start_date,
        end_date,
      }) => {
        const params = {
          page,
          limit,
          q,
          input_group,
          category,
          mapped_activities,
          organization_taxonomy,
          start_date,
          end_date,
        };

        // Filter out undefined parameters
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(([_, v]) => v !== undefined)
        );
        return {
          url: `/emissions/emission-input-items-dashboard/`,
          params: filteredParams,
        };
      },
      providesTags: ["input-items"],
    }),
    getGenericUploadFiles: builder.query({
      query: ({ page = 1, limit = 100 }) => {
        return {
          url: `/emissions/portfolio/`,
          params: {
            page,
            limit,
            generic_files: true,
          },
        };
      },
      providesTags: ["input-items"],
    }),
    uploadGenericFile: builder.mutation({
      query: (body) => {
        return {
          url: `/emissions/portfolio/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["input-items"],
    }),
    downloadExcelTemplate: builder.query({
      query: () => {
        return {
          url: `/emissions/template_excel/`,
          headers: {
            accept: `*/*`,
          },
          responseType: "blob",
        };
      },
      invalidatesTags: ["input-items"],
    }),
    Uploadcustomdatastream: builder.mutation({
      query: ({ token, payload, queryParams }) => {
        const queryString = new URLSearchParams(queryParams).toString();
        // const queryString = { category: "Ot her Category" }.toString()
        console.log("payloadishere", payload);

        return {
          url: `/upload_file/?${queryString}`,
          method: "POST",
          body: payload,

          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantId,
          },
        };
      },
      invalidatesTags: ["input-items"],
    }),
    getItemsHistory: builder.query({
      query: (params) => {
        return {
          url: `/emissions/emission-input-items/history/`,
          params,
        };
      },
      invalidatesTags: ["input-items"],
    }),
    getSingleItemHistory: builder.query({
      query: (id) => {
        return {
          url: `/emissions/emission-input-items/${id}/history/`,
        };
      },
      invalidatesTags: ["input-items"],
    }),
    bulkDeleteItems: builder.mutation({
      query: (filename) => {
        return {
          url: `/emissions/emission-input-items/destroy/?file_name=${filename}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["input-items"],
    }),
    getEmissionInputItems: builder.query({
      query: ({ category, taxonomyId, startDate, endDate }) => {
        let queryParams = [];
        if (category) {
          queryParams.push(`category=${category}`);
        }
        if (taxonomyId) {
          queryParams.push(`organization_taxonomy=${taxonomyId}`);
        }
        if (startDate) {
          queryParams.push(`start_date=${startDate}`);
        }
        if (endDate) {
          queryParams.push(`end_date=${endDate}`);
        }

        const url = `emissions/emission-input-items/?${queryParams.join("&")}`;
        return {
          url: url,
        };
      },
      providesTags: ["input-items"],
    }),

    getEmissionGasBreakdown: builder.query({
      query: ({ startDate, endDate, taxonomyId }) => {
        let queryParams = [];
        if (taxonomyId) {
          queryParams.push(`node=${taxonomyId}`);
        }
        if (startDate) {
          queryParams.push(`start_date=${startDate}`);
        }
        if (endDate) {
          queryParams.push(`end_date=${endDate}`);
        }

        const url = `emissions/emission-input-items-other/?${queryParams.join(
          "&"
        )}`;
        return {
          url: url,
        };
      },
      providesTags: ["input-items"],
    }),

    getQuantificationApproach: builder.query({
      query: ({ startDate, endDate }) => {
        let queryParams = [];

        if (startDate) {
          queryParams.push(`start_date=${startDate}`);
        }
        if (endDate) {
          queryParams.push(`end_date=${endDate}`);
        }

        const url = `reports/quantification/?${queryParams.join("&")}`;
        return {
          url: url,
        };
      },
      providesTags: ["input-items"],
    }),
    Uploadbasematric: builder.mutation({
      query: ({ payload }) => {
        console.log("payloadishere", payload);

        return {
          url: `/emissions/base-matrics-upload/`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["input-items"],
    }),
    getUploadbasematric: builder.query({
      query: (params) => {
        return {
          url: `/emissions/base-matrics-upload/`,
          params,
        };
      },
      invalidatesTags: ["input-items"],
    }),
    deleteUploadedMatricFile: builder.mutation({
      query: (filename) => ({
        url: "/emissions/base-matrics-file-delete/",
        method: "POST",
        body: filename,
      }),
        invalidatesTags: ["base-metric"],
    }),
    downloadBaseMatricItemExport: builder.query({
    query: () => {
    return {
      url: `/emissions/base-matric-items-export/`,
      responseType: "blob",
      headers: {
        Accept: "*/*",
      },
      responseHandler: (response) => response.blob(),     };
  },
}),

  }),
});

export const {
  useCreateInputItemMutation,
  useGetCategoriesWithEmissionsQuery,
  useGetCategoryInputItemsQuery,
  useUploadInputItemsMutation,
  useGetPortfolioListQuery,
  useUpdateInputItemMutation,
  useDeleteInputItemMutation,
  useDeleteUploadedFileMutation,
  useRetainRejectInputItemMutation,
  useGetCeleryTaskStatusQuery,
  useGetAllEmissionWithQuery,
  useGetPurchasedGoodsStatsQuery,
  useGetUploadInputItemsDataQuery,
  useGetPurchasedGoodsInputItemsQuery,
  useGetUploadInputItemsQuery,
  useDownloadExcelTemplateQuery,
  useUploadGenericFileMutation,
  useUploadcustomdatastreamMutation,
  useGetGenericUploadFilesQuery,
  useGetItemsHistoryQuery,
  useUploadbasematricMutation,
  useGetUploadbasematricQuery,
  useDeleteUploadedMatricFileMutation,
  useGetSingleItemHistoryQuery,
  useBulkDeleteItemsMutation,
  useLazyGetEmissionInputItemsQuery, //new end-point
  useGetEmissionGasBreakdownQuery,
  useGetQuantificationApproachQuery,
  useLazyDownloadBaseMatricItemExportQuery,
} = inputItemsApi;
